module.exports = __webpack_public_path__ + "img/11_64.8db209b2.png";